import { getDropzoneAcceptedFormats } from '@carboncopyco/utils';
import type { DropEvent, FileRejection } from 'react-dropzone';
import { useDropzone } from 'react-dropzone';

export interface UseImageDropzoneProps {
  disabled?: boolean;
  onDropAccepted: (file: File, event: DropEvent) => void;
  onDropRejected: (file: FileRejection, event: DropEvent) => void;
}

const supportedImageFormats = ['JPG', 'JPEG', 'PNG', 'GIF'];

export const useImageDropzone = ({
  disabled,
  onDropAccepted,
  onDropRejected,
}: UseImageDropzoneProps) =>
  useDropzone({
    disabled,
    multiple: false,
    maxSize: 10485760,
    minSize: 0,
    accept: getDropzoneAcceptedFormats(supportedImageFormats, 'image'),
    maxFiles: 1,
    onDropAccepted: (files, event) => onDropAccepted(files[0], event),
    onDropRejected: (files, event) => onDropRejected(files[0], event),
  });
